import { type FC } from 'react';
import { type ColorlessIconProps, IconBlockFilled, IconPlayFilled } from '@direct-frontend/components';
import { type OpenApiSchemaPromocodeGroup } from '#shared/api/schema';
import { type PromoactionMode, type PromoactionModel, type PromoactionType } from './types';

export const PROMOACTIONS_STATUSES = {
    active: 'active',
    inactive: 'inactive',
} satisfies Record<OpenApiSchemaPromocodeGroup['status'], OpenApiSchemaPromocodeGroup['status']>;

export const PROMOACTIONS_STATUSES_LIST = Object.values(PROMOACTIONS_STATUSES);

export const STATUS_ICON_MAP: Record<
    Required<PromoactionModel>['meta']['status'],
    { baseProps: Pick<ColorlessIconProps, 'color'>; Icon: FC<ColorlessIconProps> }
> = {
    active: { Icon: IconPlayFilled, baseProps: { color: 'blue' } },
    inactive: { Icon: IconBlockFilled, baseProps: { color: 'red' } },
};

export const PROMOACTION_TYPES = {
    on_products: 'on_products',
    on_orders: 'on_orders',
    // Лестница скидок
    ladder: 'ladder',
} satisfies Record<PromoactionType, PromoactionType>;

export const PROMOACTION_TYPES_LIST = Object.values(PROMOACTION_TYPES);

export const PROMOACTIONS_MODE: { [key in PromoactionMode]: key } = {
    promocode: 'promocode',
    automatic: 'automatic',
};
